export const STATS_OK = 'STATS_OK';
export const STATS_FAILED = 'STATS_FAILED';
export const IS_LOADING = 'STATS_LOADING';

export const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case STATS_OK:
      return { ...state, data: action.data, error: null };

    case STATS_FAILED:
      return { ...state, error: action.data };

    case IS_LOADING:
      return { ...state, isLoading: action.data };

    default:
      return state;
  }
};

export const createAction = ({ action, dispatch, onSuccess, onError }) => {
  if (typeof action === 'function') {
    action = action();
  }

  dispatch({ type: IS_LOADING, data: true });

  return Promise.resolve(action)
    .then(data => {
      if (typeof onSuccess === 'function') {
        onSuccess(data, dispatch);
      }
      return data;
    })
    .catch(err => {
      if (typeof onError === 'function') {
        onError(err, dispatch);
      }
    })
    .finally(() => {
      dispatch({ type: IS_LOADING, data: false });
    });
};

export const successHandler = (statName) => (data, dispatch) => {
  dispatch({ type: STATS_OK, stat: statName, data: { [statName]: data } });
};

export const errorHandler = (statName) => (err, dispatch) => {
  dispatch({ type: STATS_FAILED, stat: statName, data: err });
};


const statsHelper = (getStatsAction) => {
  const apiHandler = ({ model, action, onSuccess }) => {
    model.actions.setLoading(true);
    return Promise.resolve(action)
      .then((data) => {
        if (typeof onSuccess === 'function') onSuccess(data);
        return data;
      })
      .catch(model.actions.setError)
      .finally(() => {
        model.actions.setLoading(false);
      });
  };

  const setLoading = (model, val) => {
    model.actions.setState({
      ...model.state,
      isLoading: val,
    });
  };

  const setError = (model, err) => {
    model.actions.setState({
      ...model.state,
      error: err,
    });
  };

  const getStats = (model, ...args) => apiHandler({
    model,
    action: getStatsAction(...args),
    onSuccess: (data) => {
      if (!data) return;
      model.actions.setState({
        ...model.state,
        data,
      });
    },
  });


  return {
    setLoading,
    setError,
    getStats,
  };
}

export default statsHelper;
